import { render, staticRenderFns } from "./StaffResourceTable.vue?vue&type=template&id=376e3e5c&scoped=true"
import script from "./StaffResourceTable.vue?vue&type=script&lang=js"
export * from "./StaffResourceTable.vue?vue&type=script&lang=js"
import style0 from "./StaffResourceTable.vue?vue&type=style&index=0&id=376e3e5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e3e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376e3e5c')) {
      api.createRecord('376e3e5c', component.options)
    } else {
      api.reload('376e3e5c', component.options)
    }
    module.hot.accept("./StaffResourceTable.vue?vue&type=template&id=376e3e5c&scoped=true", function () {
      api.rerender('376e3e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staffManage/resource/components/StaffResourceTable.vue"
export default component.exports